import { Button, Text } from '@kanda-libs/ks-design-library';

import CheckList from 'components/CheckList';

import Header from './Header';
import { LIST_TITLE } from './constants';
import useApplyWelcome from './useApplyWelcome';

import ApplyCard from '../components/Card';

const ApplyWelcome: React.FunctionComponent = function () {
  const {
    provider,
    tradingName,
    isLoading,
    isExampleJob,
    isIntroduced,
    list,
    onClick,
  } = useApplyWelcome();
  return (
    <ApplyCard>
      <Header
        provider={provider as string}
        tradingName={tradingName}
        isLoading={isLoading}
        isExampleJob={isExampleJob}
        isIntroduced={isIntroduced}
      />
      <Text {...LIST_TITLE} isLoading={isLoading} />
      <CheckList items={list} isLoading={isLoading} />
      <Button.Text
        id="apply-welcome-next"
        label="Continue"
        icon="arrow-right"
        variant="gradient"
        onClick={onClick}
        disabled={isLoading}
        isLoading={isLoading}
        className="mt-6"
      />
    </ApplyCard>
  );
};

export default ApplyWelcome;
